import * as React from 'react';
import { SVGProps } from 'react';

const IconChatStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m7.177 17.958-1.193 4.058 4.058-1.193 1.007.448A8.46 8.46 0 0 0 14.5 22 8.5 8.5 0 1 0 6 13.5c0 1.235.261 2.4.729 3.45l.448 1.008Zm-3.972 8.003a.94.94 0 0 1-1.166-1.166l1.949-6.625A11.46 11.46 0 0 1 3 13.5C3 7.149 8.149 2 14.5 2S26 7.149 26 13.5 20.851 25 14.5 25a11.46 11.46 0 0 1-4.67-.988l-6.625 1.949Z"
    />
  </svg>
);
export default IconChatStrokedSizeL;
